import DbPermissionGuard, { DB_PERMISSION_MODULE, DB_PERMISSION_LEVEL } from "../../component/guards/DbPermissionGuard";

// Route guard for Sales News VGSAP admin-only pages
// Wrapper around DbPermissionGuard for admin access
function AdminRouteGuard({ children }) {
	return (
		<DbPermissionGuard
			module={DB_PERMISSION_MODULE.SALES_NEWS_VGSAP}
			level={DB_PERMISSION_LEVEL.ADMIN}
			redirectTo="/sales-news/sales-news-vgsap"
		>
			{children}
		</DbPermissionGuard>
	);
}

export default AdminRouteGuard;
